import React, { Component } from 'react';
import { withApollo, compose } from 'react-apollo';

import { CreateTaskSelectedOption } from '../../../mutations/CreateTaskSelectedOption';
import TaskView from './TaskView';
import withClaimQuery from '../withClaimQuery';

class CallPaxTask extends Component {
  state = { litigationModalOpen: false };

  handleTaskUpdate = ({target}) => {
    const selectedOption = target.name
    const { client, task, onTaskComplete } = this.props;
    const taskId = task ? task.id : '';
    this.setState({ loading: true });
    client
      .mutate({
        mutation: CreateTaskSelectedOption,
        variables: {
          input: {
            taskId,
            selectedOption
          }
        }
      })
      .then(() => {
        this.setState({ loading: false });
        onTaskComplete();
      })
      .catch(() => this.setState({ loading: false }));
  };

  handleLitigationModalOpen = () =>
    this.setState({ litigationModalOpen: true });

  handleLitigationModalClose = () =>
    this.setState({ litigationModalOpen: false });

  render = () => {
    const { claim, task, onClaimClosed, loading } = this.props;
    const { litigationModalOpen } = this.state;
    return (
      <TaskView
        task={task}
        claim={claim}
        loading={loading || this.state.loading}
        onTaskUpdate={this.handleTaskUpdate}
        litigationModalOpen={litigationModalOpen}
        onLitigationModalOpen={this.handleLitigationModalOpen}
        onLitigationModalClose={this.handleLitigationModalClose}
        onClaimClosed={onClaimClosed}
      />
    );
  };
}

const CallPaxTaskWithData = compose(
  withApollo,
  withClaimQuery
)(CallPaxTask);

export default CallPaxTaskWithData;



// WEBPACK FOOTER //
// ./src/component/tasks/CallPaxTask/index.js